import { Outlet } from 'react-router';
import { useEvent } from '../lib/queries';
import { SiteFooter } from './SiteFooter';
import { TabBar } from './TabBar';
import { TopBar } from './TopBar';

/**
 * Home: the client's lockup on top, the footer underneath, and no tab bar in between.
 *
 * The lockup header is the phone's. On a laptop the shell's own header carries the same mark and
 * the same avatar, and a second one under it would be the app introducing itself twice.
 */
export function HomeLayout() {
  const event = useEvent();

  return (
    <>
      <div className="lg:hidden">
        <TopBar event={event.data} />
      </div>
      <div className="flex-1">
        <Outlet />
      </div>
      <SiteFooter event={event.data} />
    </>
  );
}

/**
 * Every other screen: its own header, and the tab bar. The bar is fixed, so the column ends
 * with enough room to scroll the last card clear of it — room that comes back on a laptop, where
 * the destinations are in the header and nothing covers the bottom of the screen.
 */
export function ScreenLayout() {
  return (
    <>
      <div className="flex-1 pb-[calc(var(--spacing-tabbar)+env(safe-area-inset-bottom))] lg:pb-0">
        <Outlet />
      </div>
      <TabBar />
    </>
  );
}
